import React, { useEffect, useState } from "react";

/**
 * Toast de notification — supporte undo (5s), success (3s), error (4s).
 */
function Toast({ message, type = "undo", duration, onUndo, onExpire }) {
  const [visible, setVisible] = useState(true);

  const effectiveDuration = duration || (type === "success" ? 3000 : type === "error" ? 4000 : 5000);

  useEffect(() => {
    const timer = setTimeout(() => {
      setVisible(false);
      onExpire?.();
    }, effectiveDuration);
    return () => clearTimeout(timer);
  }, [effectiveDuration, onExpire]);

  if (!visible) return null;

  const className = `toast${type !== "undo" ? ` toast-${type}` : ""}`;

  return (
    <div className={className} role="alert" aria-live="assertive">
      <span className="toast-message">{message}</span>
      {onUndo && (
        <button className="toast-undo" onClick={() => { setVisible(false); onUndo(); }}>
          Annuler
        </button>
      )}
    </div>
  );
}

export default Toast;
